import type { ActionSpecification } from "@app/components/agent_builder/types";
import { AzimutTools } from "@dust-tt/sparkle";

export const MCP_SPECIFICATION: ActionSpecification = {
  label: "More...",
  description: "Add additional sets of tools",
  cardIcon: AzimutTools,
  dropDownIcon: AzimutTools,
  flag: null,
};
